import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { map } from "lodash";

// Components
import dataHandler from "@Utils/dataHandler";
import Screen from "@Components/Screen";

// Redux
import { connect } from "react-redux";
import genericAction from "@Actions/generic";

// Modal
import ConfirmModal from "@Modals/ConfirmModal";
import IkTable from "@Components/IkTable";
import CategoryCrud from "./Modals/CategoryCrud";

// Styles
import styles from "./styles.module.css";

const restrictionLabels = {
	tags: "Etiquetas",
	quickanswers: "Respuestas rápidas",
};

const reverseRestrictionLabels = Object.fromEntries(
	Object.entries(restrictionLabels).map(([key, value]) => {
		return [value, key];
	})
);

const CategoryInquiry = ({ dispatch, userName, companyName }) => {
	const [openConfirmModal, setOpenConfirmModal] = useState(false);
	const [openCategoryCrud, setOpenCategoryCrud] = useState(false);
	const [tableValue, setTableValue] = useState([]);
	const [typesList, setTypesList] = useState([]);
	const [filteredItems, setFilteredItems] = useState([]);
	const [modalOption, setModalOption] = useState([]);
	const [filteredCount, setfilteredCount] = useState(null);
	const [filteredPrintData, setFilteredPrintData] = useState([]);

	const defaultParams = { page: 1, orderKey: "id", orderDir: "desc", rows: 15 };

	useEffect(() => {
		(async () => {
			const categoriesPromise = dataHandler({ dispatch, url: "category", params: defaultParams });
			const typesCategoryPromise = dispatch(genericAction({ method: "get", route: "types/categories" }));

			const [categoriesResponse, typesPromise] = await Promise.all([categoriesPromise, typesCategoryPromise]);

			const translatedItems = map(categoriesResponse.items, (item) => {
				return {
					...item,
					restriction: map(item.restriction || [], (transla) => {
						return restrictionLabels[transla.toLowerCase()] || transla;
					}),
				};
			});

			setFilteredItems(translatedItems);
			setfilteredCount(categoriesResponse.count);
			setTypesList(typesPromise);
		})();
	}, []);

	const modalData = (name, item) => {
		const itemWithOriginalRestriction = {
			...item,
			restriction: map(item.restriction || [], (translaData) => {
				return reverseRestrictionLabels[translaData] || translaData;
			}),
		};

		setModalOption(name);
		setOpenCategoryCrud(true);
		setTableValue(itemWithOriginalRestriction);
	};

	const apiData = async (name) => {
		switch (name) {
			case "Edit":
				setOpenCategoryCrud(false);
				break;

			case "Eraser":
				setOpenConfirmModal(false);
				await dispatch(genericAction({ method: "delete", route: `category/${tableValue.id}` }));
				break;
			default:
				break;
		}
		const profilesResponse = await dataHandler({
			dispatch,
			url: "category",
			params: defaultParams,
		});

		setfilteredCount(profilesResponse.count);

		const translatedItems = map(profilesResponse.items, (item) => {
			return {
				...item,
				restriction: map(item.restriction || [], (r) => {
					return restrictionLabels[r.toLowerCase()] || r;
				}),
			};
		});

		setFilteredItems(translatedItems);
	};

	const handleButtom = (name, item) => {
		switch (name) {
			case "Watch":
			case "Edit":
				modalData(name, item);
				break;
			case "Eraser":
				setOpenConfirmModal(true);
				setTableValue(item);
				break;
			case "Add":
				modalData(name, []);
				break;
			default:
				break;
		}
	};

	const handlerData = async (params, printable) => {
		const data = await dataHandler({ dispatch, url: "category", params });

		const translatedItems = map(data.items, (item) => {
			return {
				...item,
				restriction: map(item.restriction || [], (translaHandler) => {
					return restrictionLabels[translaHandler.toLowerCase()] || translaHandler;
				}),
			};
		});

		if (printable) {
			setFilteredPrintData(translatedItems);
		} else {
			setFilteredItems(translatedItems);
			setfilteredCount(data.count);
		}
	};

	const refresh = async () => {
		const categoriesResponse = await dataHandler({
			dispatch,
			url: "category",
			params: defaultParams,
		});

		const translatedItems = map(categoriesResponse.items, (item) => {
			return {
				...item,
				restriction: map(item.restriction || [], (r) => {
					return restrictionLabels[r.toLowerCase()] || r;
				}),
			};
		});

		setFilteredItems(translatedItems);
		setfilteredCount(categoriesResponse.count);
	};

	return (
		<Screen hasSidebar hasHeader headerTitle="Categorías">
			<div className={styles.container}>
				<div className={styles.containerTableGroup}>
					<IkTable
						data={filteredItems}
						columns={[
							{
								label: "Acciones",
								action: [
									{ content: "trash", color: "#b43333", onClick: "Eraser", type: "icon" },
									{ content: "edit", color: "#3f7ea3", onClick: "Edit", type: "icon" },
								],
								dataPosition: "center",
								width: 1,
								canFilter: false,
								canSort: false,
							},
							{
								label: "ID",
								key: "id",
								format: "string",
								dataPosition: "center",
								width: 1,
							},
							{
								label: "Nombre",
								key: "name",
								format: "string",
								headerPosition: "left",
								width: 2,
							},
							{
								label: "Tipos",
								format: "arrayTruncate",
								key: "restriction",
								headerPosition: "left",
								width: 3,
							},
							{
								label: "Aplica Nota",
								key: "settings.aplica_nota",
								format: "boolean",
								headerPosition: "left",
								width: 18,
							},
						]}
						print={{ printHeader: { company: companyName, title: "Categoría", user: userName } }}
						totalRows={filteredCount}
						filteredPrintData={filteredPrintData}
						defaultParams={defaultParams}
						dataHandler={handlerData}
						handlerTable={handleButtom}
						searcher={{ width: "40rem" }}
						addButton={{ label: "Agregar" }}
					/>
				</div>
			</div>

			{openCategoryCrud && (
				<CategoryCrud
					typesList={typesList}
					apiData={apiData}
					tableValue={tableValue}
					onClose={() => {
						return setOpenCategoryCrud(false);
					}}
					modalCrud={modalOption}
					refresh={refresh}
				/>
			)}

			{openConfirmModal && (
				<ConfirmModal
					visible
					icon="exclamation circle"
					buttonLabel="Eliminar"
					header="Confirmar"
					content="Está seguro que desea eliminar la categoría"
					focus={tableValue.name}
					onConfirm={() => {
						return apiData("Eraser");
					}}
					onDismiss={() => {
						return setOpenConfirmModal(false);
					}}
				/>
			)}
		</Screen>
	);
};

function mapStateToProps({ user, company }) {
	return {
		companyName: company.name,
		userName: user.name,
	};
}

CategoryInquiry.propTypes = {
	dispatch: PropTypes.func,
	companyName: PropTypes.string,
	userName: PropTypes.string,
};

export default connect(mapStateToProps)(CategoryInquiry);
